export default "__VITE_ASSET__Bvm4xjNR__"